import Image from "@namia/image";
import React from "react";

const HcUl = ({ image, ul, headline }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-ul wp-block-kehittamo-block-hc">
      <div className="flex justify-center items-center">
        <div className="px-4 py-3 flex gap-3 xl:gap-16 flex-col items-center xl:flex-row">
          <div className="max-w-[740px] xl:w-2/3 xl:pr-7 ">
            <h2 className="text-xl font-bold xl:text-4xl xl:mb-6">
              {headline}
            </h2>
            <ul className="space-y-2">
              {ul.map(({ li }, index) => (
                <li key={index} className="flex gap-2">
                  <i className="pt-1.5">
                    <svg
                      height="14px"
                      width="14px"
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 512 512"
                      xmlSpace="preserve"
                    >
                      <polygon
                        fill="var(--color-muotolevy-red)"
                        points="25.045,128 256,0 486.955,128 486.955,384 256,512 25.045,384 "
                      />
                    </svg>
                  </i>
                  <span className="text-base font-semibold">{li}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="max-w-96 xl:w-1/3">
            <Image
              className=""
              alt="alt"
              base64={image.base64}
              onError={() => {}}
              placeholder={image.placeholder}
              onLoad={() => {}}
              placeholderBase64={image.placeholderBase64}
              ratio={image.width / image.height}
              src={image.src}
              srcset={image.srcset}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HcUl;
